export class Sidebar {
  constructor(sidebarSelector) {
    this.sidebarSelector = sidebarSelector;
    this.bindEvents();
  }

  bindEvents() {
    [...document.querySelectorAll(`${this.sidebarSelector} li > ul`)].forEach((subnav) => {
      let link = subnav.previousSibling;

      while (link !== null && link.tagName !== 'A') {
        link = link.previousSibling;
      }

      link.addEventListener('click', () => {
        link.classList.contains('active')
          ? this.contract(link, subnav)
          : this.expand(link, subnav);
      });
    })
  }

  expand(link, subnav) {
    link.classList.add('active');
  }

  contract(link, subnav) {
    link.classList.remove('active');
  }
}
